import { SubTitle, Text, Title } from "theme/theme";
import styled from 'styled-components';
import { Type } from './../../../../theme/types/generic.interface';

export const TitleRange = styled(Title)`
  font-size: 2.25rem;
  ${({ theme }: Type) => theme.range?.text?.title}
`

export const SubTitleRange = styled(SubTitle)`
  font-size: 1rem;
  ${({ theme }: Type) => theme.range?.text?.subtitle}
`

export const TextCongratsRange = styled(Text)`
  font-size: 10px;
  ${({ theme }: Type) => theme.range?.text?.text}
`